import { decorators } from '@sohohouse/platform-resources'

export default (_, inject) => {
  inject('decorators', {
    ...decorators.dh,
    ...decorators.shared
  })
}
